export type UUIDString = `${string}-${string}-${string}-${string}-${string}`;

/**
 * Safe polyfill for generating UUIDs
 */
let uuid: () => UUIDString;

if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
  if (crypto.randomUUID) {
    uuid = () => crypto.randomUUID();
  } else {
    uuid = () => {
      // getRandomValues is more widely supported and can be used as a more secure polyfill
      // before reaching for non-cryptographic random number generation
      // Implementation taken from https://stackoverflow.com/a/2117523
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
        (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
      ) as UUIDString;
    };
  }
} else {
  uuid = () => {
    /**
     * Fallback to a non-cryptographic random number generator if we have to.
     * If we get to this point a lot of other stuff is probably broken, but we'll
     * try our best anyways.
     * Taken from https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }) as UUIDString;
  };
}

export { uuid };
